export const Main = ({ children }) => {
    return (<div className='main-cont'>
        {children}
    </div>)
}